// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FpJQ75sR5dK4CmvjREid{flex-direction:row;height:100%;display:flex;position:relative;overflow-y:auto}.x1Frysv1GN4U4v9WT2dk{flex-direction:column;width:760px;margin-top:24px;display:flex;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `FpJQ75sR5dK4CmvjREid`,
	"content": `x1Frysv1GN4U4v9WT2dk`
};
export default ___CSS_LOADER_EXPORT___;
